import { render, staticRenderFns } from "./AchAuthorizationContent.vue?vue&type=template&id=d0aac384&"
import script from "./AchAuthorizationContent.vue?vue&type=script&lang=js&"
export * from "./AchAuthorizationContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports